import { useEffect } from 'react';
import { initVisitor } from '@meiqia/utils';

function useSocketEventOn(props) {
  const { im, onQueueAdd, onQueueRemove, onQueueOffline, onQueueOnline } = props;

  const handleQueueAdd = stream => {
    const defaultAttr = {
      status: true
    };
    onQueueAdd(initVisitor({ ...stream.body, ...defaultAttr }));
  };

  const handleQueueRemove = stream => {
    if (stream?.body?.track_ids) {
      onQueueRemove(stream.body.track_ids);
    }
  };

  const handleQueueOffline = stream => {
    setTimeout(() => {
      if (stream && stream.length > 0) {
        onQueueOffline(stream);
      }
    });
  };

  const handleQueueOnline = stream => {
    if (stream && stream.length > 0) {
      onQueueOnline(stream);
    }
  };

  useEffect(() => {
    // 排队的上线与下线
    im.on('queueAdd', handleQueueAdd);
    im.on('queueRemove', handleQueueRemove);
    im.on('offline', handleQueueOffline);
    im.on('online', handleQueueOnline);

    return () => {
      im.off('queueAdd', handleQueueAdd);
      im.off('queueRemove', handleQueueRemove);
      im.off('offline', handleQueueOffline);
      im.off('online', handleQueueOnline);
    };
  }, []);
}

export default useSocketEventOn;
